import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const VendorModule = {
  state: {
    loading: false,
    errorMessage: null,
    VendorData: [],
    totalPages: 1,
    Saveloading: false,
    saveError: null,
  },

  getters: {
    Vendorloading: (state) => state.loading,
    VendorData: (state) => state.VendorData,
    Error: (state) => state.Error,
    TotalPages: (state) => state.totalPages,
    errorMessage: (state) => state.errorMessage,
    Saveloading: (state) => state.Saveloading,
    saveError: (state) => state.saveError,
  },
  actions: {
    [ACTIONS.VENDORS_GETALL]: (context, query) => {
      var { commit, state } = context;
      commit(ACTIONS.VENDORS_GETALL_PENDING);

      return new Promise((resolve, reject) => {
        let url =
          "/Vendors/GetAll" +
          (query == null ? "?currentpage=1&pagesize=10&search=" : query);
        Api.get(url, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.VENDORS_GETALL_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 1 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.VENDORS_GETALL_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.VENDORS_GETALL_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              commit(ACTIONS.VENDORS_GETALL_ERROR, "Error " + err.status);
            }
            if (err.request) {
              commit(ACTIONS.VENDORS_GETALL_ERROR, err.message);
            } else {
              // Something happened in setting up the request that triggered an Error

              commit(ACTIONS.VENDORS_GETALL_ERROR, "Error " + err.message);
            }

            return reject(err);
          });
      });
    },

    [ACTIONS.VENDORS_CHECK_DUP_NAME]: (context, data) => {
      return new Promise((resolve, reject) => {
        let url = "vendors/CheckDuplicateName";
        var params = new URLSearchParams();
        params.append("value", data.value);
        params.append("otherData[0].key", "id");
        params.append("otherData[0].value", data.id == null ? 0 : data.id);
        Api.post(url, params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (res.status == 200) {
              return resolve({
                data: data.isValid,
              });
            } else {
              return resolve({
                data: true,
              });
            }
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.VENDORS_GETALL_ERROR,
                  "Error " + data.Message,
                );
              } else {
                context.commit(
                  ACTIONS.VENDORS_GETALL_ERROR,
                  "Error " + err.status,
                );
              }
            }
            if (err.request) {
              context.commit(
                ACTIONS.VENDORS_GETALL_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.VENDORS_GETALL_ERROR,
                "Error " + err.message,
              );
            }

            return reject({
              data: true,
            });
          });
      });
    },

    [ACTIONS.VENDORS_SAVE]: (context, data) => {
      return new Promise((resolve, reject) => {
        var { commit } = context;
        context.commit(ACTIONS.VENDORS_SAVE_PENDING);
        var params = new URLSearchParams();
        params.append("Name", data.Name);
        params.append("Address", data.Address);
        params.append("ContactNo", data.ContactNo);
        params.append("Email", data.Email);
        params.append("AccNo", data.AccNo);
        params.append("Type", data.VendorTypeObject);
        params.append("Deleted", data.Deleted == false ? 0 : 1);
        params.append("ContractDate", data.formattedCOntractdate);
        params.append("Id", data.VendorId == null ? 0 : data.VendorId);
        Api.post("vendors/add", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.VENDORS_SAVE_SUCCESS, data.ResponseData);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.VENDORS_SAVE_ERROR, data.StatusMessage);
            } else if (data && data.StatusCode == 450) {
              commit(ACTIONS.VENDORS_SAVE_ERROR, "Data is not valid format.");
              return resolve(res);
            } else {
              commit(ACTIONS.VENDORS_SAVE_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.VENDORS_SAVE_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.VENDORS_SAVE_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.VENDORS_SAVE_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.VENDORS_SAVE_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
    [ACTIONS.VENDOR_EDIT_REQUEST]: (context, VendorId) => {
      return new Promise((resolve, reject) => {
        var { commit } = context;
        commit(ACTIONS.VENDORS_SAVE_PENDING);
        Api.get("vendors/GetVendor" + "?id=" + VendorId, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 200) {
              commit(ACTIONS.VENDOR_EDIT_REQUEST_SUCCESS);
              return resolve(res);
            } else if (
              data &&
              (data.StatusCode == 500 ||
                data.StatusCode == 403 ||
                data.StatusCode == 2 ||
                data.StatusCode == 429 ||
                data.StatusCode == 1 ||
                data.StatusCode == 406 ||
                data.StatusCode == 0)
            ) {
              commit(ACTIONS.VENDORS_SAVE_ERROR, data.StatusMessage);
            } else {
              commit(ACTIONS.VENDORS_SAVE_ERROR, "Unknown Error");
            }
            return resolve(res);
          })
          .catch((err) => {
            if (err.response) {
              var { data } = err.response;
              if (err.response.status == 500) {
                context.commit(
                  ACTIONS.VENDORS_SAVE_ERROR,
                  "Internal server error",
                );
              } else {
                context.commit(
                  ACTIONS.VENDORS_SAVE_ERROR,
                  "Error " + err.status,
                );
              }
            } else if (err.request) {
              context.commit(
                ACTIONS.VENDORS_SAVE_ERROR,
                "Error " + err.request,
              );
            } else {
              // Something happened in setting up the request that triggered an Error

              context.commit(
                ACTIONS.VENDORS_SAVE_ERROR,
                "Error " + err.message,
              );
            }
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.VENDORS_GETALL_PENDING]: (state) => {
      state.loading = true;
      state.errorMessage = null;
    },
    [ACTIONS.VENDORS_GETALL_SUCCESS]: (state, data) => {
      state.loading = false;
      state.errorMessage = null;
      state.totalPages = data.totalRecords;
      state.VendorData = data.vendors;
    },
    [ACTIONS.VENDORS_GETALL_ERROR]: (state, msg) => {
      state.loading = false;
      state.errorMessage = msg;
    },
    [ACTIONS.VENDORS_SAVE_PENDING]: (state) => {
      state.Saveloading = true;
      state.saveError = null;
    },
    [ACTIONS.VENDORS_SAVE_SUCCESS]: (state) => {
      state.Saveloading = false;
      state.saveError = null;
    },
    [ACTIONS.VENDOR_EDIT_REQUEST_SUCCESS]: (state) => {
      state.Saveloading = false;
      state.saveError = null;
    },
    [ACTIONS.VENDORS_SAVE_ERROR]: (state, msg) => {
      state.Saveloading = false;
      state.saveError = msg;
    },
  },
};

export default VendorModule;
